/**
 * 学习乐园 · 排排序题材包：乘法口诀（paixu/pack-koujue.js）
 * ---------------------------------------------------------------------------
 * 每局从 45 句小九九里随机抽 8 句，按口诀表的标准读写顺序排回（m 选 n）。
 * 顺序口径 = 传统小九九表：按大因数分组（一一得一；一二得二、二二得四；……），
 * 组内小因数在前——这就是背口诀的行进顺序，考的是「第几句在口诀表哪个位置」
 * 的整体手感，note 全部写成「几×几」的算式口径，排一遍等于把口诀表过了一遍。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.koujue = {
    id: 'koujue',
    name: '乘法口诀',
    hint: '每局抽 8 句按口诀表顺序排',
    cols: 4,
    draw: 8,
    winText: '一一得一，一二得二，二二得四……口诀表就是这个行进顺序——竖着背横着背都顺了。',
    items: [
      { face: '一一得一', note: '1×1=1，口诀表的第一句' },
      { face: '一二得二', note: '1×2=2，2 的口诀第一句' },
      { face: '二二得四', note: '2×2=4，2 的口诀收尾' },
      { face: '一三得三', note: '1×3=3，3 的口诀第一句' },
      { face: '二三得六', note: '2×3=6' },
      { face: '三三得九', note: '3×3=9，3 的口诀收尾' },
      { face: '一四得四', note: '1×4=4，4 的口诀第一句' },
      { face: '二四得八', note: '2×4=8' },
      { face: '三四十二', note: '3×4=12，积过十后念「十二」不念「得一十二」' },
      { face: '四四十六', note: '4×4=16，4 的口诀收尾' },
      { face: '一五得五', note: '1×5=5，5 的口诀第一句' },
      { face: '二五一十', note: '2×5=10，积整十念「一十」' },
      { face: '三五十五', note: '3×5=15' },
      { face: '四五二十', note: '4×5=20' },
      { face: '五五二十五', note: '5×5=25，5 的口诀收尾' },
      { face: '一六得六', note: '1×6=6，6 的口诀第一句' },
      { face: '二六十二', note: '2×6=12' },
      { face: '三六十八', note: '3×6=18' },
      { face: '四六二十四', note: '4×6=24' },
      { face: '五六三十', note: '5×6=30' },
      { face: '六六三十六', note: '6×6=36，6 的口诀收尾' },
      { face: '一七得七', note: '1×7=7，7 的口诀第一句' },
      { face: '二七十四', note: '2×7=14' },
      { face: '三七二十一', note: '3×7=21' },
      { face: '四七二十八', note: '4×7=28' },
      { face: '五七三十五', note: '5×7=35' },
      { face: '六七四十二', note: '6×7=42' },
      { face: '七七四十九', note: '7×7=49，7 的口诀收尾' },
      { face: '一八得八', note: '1×8=8，8 的口诀第一句' },
      { face: '二八十六', note: '2×8=16' },
      { face: '三八二十四', note: '3×8=24' },
      { face: '四八三十二', note: '4×8=32' },
      { face: '五八四十', note: '5×8=40' },
      { face: '六八四十八', note: '6×8=48' },
      { face: '七八五十六', note: '7×8=56' },
      { face: '八八六十四', note: '8×8=64，8 的口诀收尾' },
      { face: '一九得九', note: '1×9=9，9 的口诀第一句' },
      { face: '二九十八', note: '2×9=18' },
      { face: '三九二十七', note: '3×9=27' },
      { face: '四九三十六', note: '4×9=36' },
      { face: '五九四十五', note: '5×9=45' },
      { face: '六九五十四', note: '6×9=54' },
      { face: '七九六十三', note: '7×9=63' },
      { face: '八九七十二', note: '8×9=72' },
      { face: '九九八十一', note: '9×9=81，口诀表的最后一句' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
